import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  isLoading: false,
  error: null,
};

export const passwordRecoverySlice = createSlice({
  name: "passwordRecovery",
  initialState,
  reducers: {
    forgotPasswordStart: (state, action) => {
      state.isLoading = true;
      state.error = null;
    },
    forgotPasswordSuccess: (state, action) => {
      state.isLoading = false;
    },
    forgotPasswordFail: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    resetPasswordStart: (state, action) => {
      state.isLoading = true;
      state.error = null;
    },
    resetPasswordSuccess: (state, action) => {
      state.isLoading = false;
    },
    resetPasswordFail: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  forgotPasswordStart,
  forgotPasswordSuccess,
  forgotPasswordFail,
  resetPasswordStart,
  resetPasswordSuccess,
  resetPasswordFail,
} = passwordRecoverySlice.actions;

const passwordRecoveryReducer = passwordRecoverySlice.reducer;

export default passwordRecoveryReducer;
